"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EntitySlideoutContent = void 0;
const JuvareTheme_1 = require("@juvare/common-web-ui/JuvareTheme");
const ModalSlideout_1 = require("@juvare/common-web-ui/ModalSlideout");
const material_1 = require("@mui/material");
const react_1 = __importDefault(require("react"));
const entitySlideoutDetailsId_1 = require("./entitySlideoutDetailsId");
function EntitySlideoutContent({ response, entityDetailsComponent: DetailsComponent, onEdit, onEditForm, onPreviewForm, }) {
    return (react_1.default.createElement(material_1.Box, { sx: { p: 2, borderTop: `1px solid ${JuvareTheme_1.themeColors.border.main}` } },
        react_1.default.createElement(ModalSlideout_1.ModalSlideoutContent, { ariaDescribeAllChildren: false },
            react_1.default.createElement(Section, null,
                react_1.default.createElement(material_1.Box, { id: entitySlideoutDetailsId_1.entitySlideoutDetailsId },
                    react_1.default.createElement(DetailsComponent, { response: response }))),
            react_1.default.createElement(Section, null,
                react_1.default.createElement(material_1.Button, { variant: 'outlined', color: 'primary', onClick: () => onEdit(), "data-test": 'edit-button' }, "Edit"),
                onEditForm && (react_1.default.createElement(material_1.Button, { sx: { ml: 2 }, variant: 'outlined', color: 'primary', onClick: () => onEditForm() }, "Edit Form")),
                onPreviewForm && (react_1.default.createElement(material_1.Button, { sx: { ml: 2 }, variant: 'outlined', color: 'primary', onClick: () => onPreviewForm() }, "Preview Form"))))));
}
exports.EntitySlideoutContent = EntitySlideoutContent;
const Section = (props) => {
    return (react_1.default.createElement(material_1.Box, { pt: 2, pb: 2, sx: {
            borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
            '&:first-of-type': {
                paddingTop: 0,
            },
            '&:last-of-type': {
                paddingBottom: 0,
                borderBottomStyle: 'none',
            },
        } }, props.children));
};
